import { getPatternStyles, patternFns } from '../helpers.mjs';
import { css } from '../css/index.mjs';

const fullScreenConfig = {
transform({ fullHeight }) {
  return {
    width: "100vw",
    minHeight: "100vh",
    height: "100%",
    ...fullHeight ? { height: "100vh" } : {}
  };
},
defaultValues:{fullHeight:false}}

export const getFullScreenStyle = (styles = {}) => {
  const _styles = getPatternStyles(fullScreenConfig, styles)
  return fullScreenConfig.transform(_styles, patternFns)
}

export const fullScreen = (styles) => css(getFullScreenStyle(styles))
fullScreen.raw = getFullScreenStyle